import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGetexVexClusterAssignmentBatchMutationVariables = Types.Exact<{
  input: Types.UpdateGetexVexClusterAssignmentBatchInput;
}>;


export type UpdateGetexVexClusterAssignmentBatchMutation = { __typename?: 'Mutation', updateGetexVexClusterAssignmentBatch: { __typename?: 'UpdateGetexVexClusterAssignmentBatchPayload', getexRegulation?: { __typename?: 'GetexRegulation', id: string } | null } };


export const UpdateGetexVexClusterAssignmentBatchDocument = gql`
    mutation UpdateGetexVexClusterAssignmentBatch($input: UpdateGetexVexClusterAssignmentBatchInput!) {
  updateGetexVexClusterAssignmentBatch(input: $input) {
    getexRegulation {
      id
    }
  }
}
    `;
export type UpdateGetexVexClusterAssignmentBatchMutationFn = Apollo.MutationFunction<UpdateGetexVexClusterAssignmentBatchMutation, UpdateGetexVexClusterAssignmentBatchMutationVariables>;

/**
 * __useUpdateGetexVexClusterAssignmentBatchMutation__
 *
 * To run a mutation, you first call `useUpdateGetexVexClusterAssignmentBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGetexVexClusterAssignmentBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGetexVexClusterAssignmentBatchMutation, { data, loading, error }] = useUpdateGetexVexClusterAssignmentBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGetexVexClusterAssignmentBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGetexVexClusterAssignmentBatchMutation, UpdateGetexVexClusterAssignmentBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGetexVexClusterAssignmentBatchMutation, UpdateGetexVexClusterAssignmentBatchMutationVariables>(UpdateGetexVexClusterAssignmentBatchDocument, options);
      }
export type UpdateGetexVexClusterAssignmentBatchMutationHookResult = ReturnType<typeof useUpdateGetexVexClusterAssignmentBatchMutation>;
export type UpdateGetexVexClusterAssignmentBatchMutationResult = Apollo.MutationResult<UpdateGetexVexClusterAssignmentBatchMutation>;
export type UpdateGetexVexClusterAssignmentBatchMutationOptions = Apollo.BaseMutationOptions<UpdateGetexVexClusterAssignmentBatchMutation, UpdateGetexVexClusterAssignmentBatchMutationVariables>;